import React from 'react';
import { TeButton } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

import { StepEnum } from '../../types/customer-modal.types';
import { BusinessPartnerCreationStepEnum } from './CompanyDivisionModal';

interface CompanyDivisionModalActionsProps {
  onClose: (shouldUpdate: boolean) => void;
  isPending: boolean;
  isNextStepDisabled: boolean;
  currentStep: BusinessPartnerCreationStepEnum;
  totalSteps: number;
  isDivision?: boolean;
  onPreviousStep: (key: StepEnum) => void;
  onNextStep: (key: StepEnum) => void;
  onSubmit: () => void;
}

const CompanyDivisionModalActions = ({
  onClose,
  isPending,
  currentStep,
  totalSteps,
  isNextStepDisabled,
  isDivision = false,
  onPreviousStep,
  onNextStep,
  onSubmit,
}: CompanyDivisionModalActionsProps) => {
  const { t } = useTranslation();
  const isFinalStep = currentStep === totalSteps;
  return (
    <>
      <TeButton
        text={t('cancel', { ns: 'common' })}
        variant="neutral"
        teclick={() => onClose(false)}
        size="s"
        disabled={isPending}
        slot="tertiary"
      />
      {currentStep > 1 && (
        <TeButton
          text={t('previousStep', { ns: 'common' })}
          variant="neutral"
          teclick={() => onPreviousStep(currentStep - 1)}
          size="s"
          disabled={isPending}
          slot="tertiary"
        />
      )}
      {isFinalStep ? (
        <TeButton
          text={
            isDivision
              ? t('createDivision', { ns: 'divisions' })
              : t('createCompany', { ns: 'companies' })
          }
          variant="primary"
          teclick={onSubmit}
          size="s"
          disabled={isPending || isNextStepDisabled}
          slot="primary"
        />
      ) : (
        <TeButton
          text={t('nextStep', { ns: 'common' })}
          variant={'primary'}
          teclick={() => onNextStep(currentStep + 1)}
          size="s"
          disabled={isNextStepDisabled || isPending}
          slot="primary"
        />
      )}
    </>
  );
};

export default CompanyDivisionModalActions;
